export enum ButtonListDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
